import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@ts-digital/vrc";
import { notification } from "antd";
import moment from "moment";
import numeral from "numeral";
import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import NumberFormat from "react-number-format";
import { useDispatch } from "react-redux";
import { openNotificationWithIcon } from "../../../libs/utils";
import { saveDestinationAmount } from "../../../store/actions/accountingYears";
import AutocompleteSelector from "../../general/autocompleteSelector/autocomplete";
import VaporDrawer from "../../general/vapor/drawer";
import { VaporDatePicker } from "../../vapor";
import "./style.scss";

const DrawerDestina = ({ amount, drawerOpeningNetIncome, setDrawerOpeningNetIncome }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [destinationAccountsList, setDestinationAccountsList] = useState([]);
  const [postingDate, setPostingDate] = useState(null);

  useEffect(() => {
    setDestinationAccountsList([{ key: 0, account: null, accountId: null, amount: amount }]);
  }, [amount]);

  const createDestinationAccount = () => {
    const arrayAllocationLines = [];
    destinationAccountsList.map(el => {
      arrayAllocationLines.push({        
        accountId: el.accountId,
        debit: {
          EUR: amount < 0 ? 0 : el.amount
        },
        credit: {
          EUR: amount > 0 ? 0 : el.amount          
        }
      });
    });

    const dataToSend = {
      postingDate: moment(postingDate).format("YYYY-MM-DD"),
      allocationLines: arrayAllocationLines
    };
    
    dispatch(saveDestinationAmount(dataToSend)).then(res => 
      openNotificationWithIcon(
        notification,
        "success",
        "",
        "Operazione correttamente presa in carico",
        null,
        null
      )).catch(err => 
      openNotificationWithIcon(
        notification,
        "error",
        "",
        "Si è verificato un errore",
        null,
        null
      ));
  };

  const renderDestinationAccount = (destinationAccount) => {
    return (
      <div
        key={`destinationAccountRender_${destinationAccount.key}`}
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          gap: "16px",
          marginBottom: "16px"
        }}
      >
        <div style={{ width: "50%" }} className="autoCompleteDestinationCC">
          <div>
            <b>
              <FormattedMessage id="accountingYear.drawer.destina.accountingAccount" />
            </b>
          </div>
          <div>
            <AutocompleteSelector
              backfill={true}
              dropdownClassName="autocompleteAccountPopover"
              value={destinationAccount?.account}
              onChange={(element) => {                
                const cloneDestinationAccounts = [...destinationAccountsList];
                cloneDestinationAccounts[destinationAccount?.key].accountId = element.code;
                cloneDestinationAccounts[destinationAccount?.key].account = element.title;
                setDestinationAccountsList(cloneDestinationAccounts);
              }}
              style={{ width: "fit-content" }}
              rowId={destinationAccount?.key}
              placeholder=""
              isAccountingAccounts={true}
              isAccountingReason={false}
              registrationData={null}
              includeSystem={true}
            />
          </div>
        </div>
        <div style={{ width: "50%" }}>
          <div>
            <b>{intl.formatMessage({ id: amount > 0 ? "accountingYear.drawer.destina.give" : "accountingYear.drawer.destina.have" })}</b>
          </div>
          <div>
            <NumberFormat
              className={"accounting-accounts-search vapor"}
              allowLeadingZeros={true}
              displayType={"input"}
              placeholder={"0 €"}
              suffix={" €"}
              thousandSeparator={"."}
              decimalSeparator={","}              
              value={destinationAccount?.amount ? numeral(destinationAccount?.amount).format("0,0.00") : null}
              onValueChange={(el) => {
                const cloneDestinationAccounts = [...destinationAccountsList];
                cloneDestinationAccounts[destinationAccount?.key].amount = el.floatValue;
                setDestinationAccountsList(cloneDestinationAccounts);
              }}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <VaporDrawer
      customClassName="drawerAccountingYear"
      visible={drawerOpeningNetIncome ? true : false}
      onClose={() => setDrawerOpeningNetIncome(false)}
      title={`${intl.formatMessage({ id: "accountingYear.drawer.destina.title" })}`}
      content={<div></div>}
      width={"44%"}
      buttons={[
        <Button key={"buttonCancelDestina"} kind="secondary" onClick={() => setDrawerOpeningNetIncome(false)}>
          <FormattedMessage id="generic.cancel" />
        </Button>,
        <Button key={"buttonContabilizzaDestina"} kind="primary" disabled={!postingDate || !destinationAccountsList[0].accountId} onClick={() => createDestinationAccount()}>
          <FormattedMessage id="accountingYear.drawer.destina.account" />
        </Button>
      ]}
      closeOnRight={true}
      closeIcon={<FontAwesomeIcon icon={["far", "arrow-left"]} style={{ color: "#0090d1", marginLeft: "16px" }} />}
    >
      <div style={{ padding: "16px 42px 32px 42px" }}>
        <div>
          <span style={{ color: "#0090d1", fontFamily: "Cairo", cursor: "pointer" }} onClick={() => setDrawerOpeningNetIncome(false)}>
            <FormattedMessage id="accountingYear.drawer.destina.linkableBreadcrumb" />
          </span>
          <span
            style={{
              verticalAlign: "middle",
              textAlign: "center",
              margin: "0 16px",
              marginBottom: "4px",
              display: "inline-block"
            }}
          >
            <FontAwesomeIcon icon={["fas", "caret-right"]} style={{ color: "#005075", fontSize: "8px", marginLeft: "16px" }} />
          </span>
          <span style={{ color: "#005075", fontFamily: "Cairo", fontWeight: "bold" }} onClick={() => setDrawerOpeningNetIncome(false)}>
            <FormattedMessage id="accountingYear.drawer.destina.currentBreadcrumb" />
          </span>
        </div>
        <div style={{ margin: "16px 0" }}>
          <div>
            <span style={{ color: "#152935" }}>
              <FormattedMessage id="accountingYear.drawer.destina.causal" />:
              <b style={{ marginLeft: "8px" }}>
                <FormattedMessage id="accountingYear.drawer.destina.causalType" />
              </b>
            </span>
          </div>
          <div style={{ marginTop: "16px" }}>
            <div>
              <b>
                <FormattedMessage id="accountingYear.drawer.destina.registrationDate" />
              </b>
            </div>
            <VaporDatePicker
              getPopupContainer={(trigger) => trigger.parentNode}
              className={"inputCustom"}
              dropdownClassName="modalOverlay"
              disabledDate={(current) => {
                return current && current < moment().subtract(1, "day");
              }}
              value={postingDate}
              onChange={(e) => setPostingDate(e)}
              defaultValue={null /* dataSource?.date ? moment(dataSource.date) : null*/}
              placeholder={"gg/mm/yyyy"}
              style={{ width: "50%", marginTop: "10px" }}
            />
          </div>
          <div style={{ marginTop: "32px", display: "flex", justifyContent: "space-between" }}>
            <div style={{ marginRight: "16px", borderRight: "1px solid #c9d9e8", display: "flex", justifyContent: "space-between", minWidth: "50%" }}>
              <div>
                <div>
                  <FormattedMessage id="accountingYear.drawer.destina.accountingAccount" />
                </div>
                <div>
                  <b>
                    <FormattedMessage id="accountingYear.drawer.destina.operatingResult" />
                  </b>
                </div>
              </div>
              <div style={{ margin: "0 16px", textAlign: "right" }}>
                <div>{intl.formatMessage({ id: amount > 0 ? "accountingYear.drawer.destina.have" : "accountingYear.drawer.destina.give" })}</div>
                <div>
                  <b>{numeral(amount).format("0,0.00")} €</b>
                </div>
              </div>
            </div>

            <div>
              {destinationAccountsList.map((el) => renderDestinationAccount(el))}
              <div
                style={{ marginTop: "48px", color: "#0090d1", cursor: "pointer" }}
                onClick={() => {
                  const cloneDestinationAccounts = [...destinationAccountsList];

                  const totalAmountCalc = cloneDestinationAccounts.reduce((a, b) => a + parseFloat(b.amount ? b.amount : 0), 0);
                  const residue = amount - totalAmountCalc;
                  cloneDestinationAccounts.push({
                    key: cloneDestinationAccounts.length,
                    account: null,
                    amount: residue > 0 ? Math.round(residue * 100) / 100  : null
                  });
                  setDestinationAccountsList(cloneDestinationAccounts);
                }}
              >
                <FontAwesomeIcon
                  icon={["fal", "plus-circle"]}
                  style={{
                    color: "#0090d1",
                    fontSize: "16px",
                    marginRight: "8px"
                  }}
                />
                <span>
                  <FormattedMessage id="accountingYear.drawer.destina.addAccount" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </VaporDrawer>
  );
};

export default DrawerDestina;
